import resourceReducerFactory, { resourceState } from 'reducers/resource';
import { types } from 'actions/account-cnams';

export const initialState = {
  ...resourceState,
};

export default resourceReducerFactory(initialState, types);
